import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getStats } from "../api";
import StatBadge from "../components/StatBadge";

export default function Home() {
  const [stats, setStats] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    getStats()
      .then(setStats)
      .catch((err) => setError(err.message));
  }, []);

  return (
    <div className="page home-page">
      <h1>Welcome back</h1>
      <p>One AWS lesson a day, generated fresh every night at midnight SGT.</p>

      {error && <p className="error">{error}</p>}

      <div className="stats-row">
        <StatBadge label="Total Reads" value={stats?.total_reads} />
      </div>

      <Link className="cta-button" to="/today">
        Read Today's Lesson
      </Link>
    </div>
  );
}
